export const permissionsUsersReadonly = [
  "users-full",
  "users-readonly",
  "everything-full",
  "everything-readonly",
];
